import { transparentize } from 'polished';
import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    width: 480px;
    height: 538px;
    border: 1px solid black;
    overflow: hidden;

    .content-wrapper {
      overflow: hidden;
      height: 100%;
      display: flex;
      flex-direction: column;
    }

    .footer-wrapper {
      border-top: 1px solid black;
      display: flex;
      justify-content: center;
      height: 50px;
      padding: 5px;
      gap: 5px;

      .footer-button {
        width: 100%;
        height: 100%;
        padding-left: 0;
        padding-right: 0;
      }

      .clear {
        border: 1px solid ${theme.colors.black};
        color: ${theme.colors.black};
        background-color: ${theme.colors.white};
        transition: 0.5s;

        &:hover {
          background-color: ${theme.colors.gray100};
          color: ${theme.colors.error};
        }
      }
    }

    .text-input-wrapper {
      font-size: ${theme.font.sizes.md};
      padding: 5px;
      border-bottom: 1px solid black;
    }

    .text-input {
      width: 100%;
      font-size: ${theme.font.sizes.md};
      border: 1px solid black;
      padding: 2px;
    }

    .filter-wrapper {
      padding: 10px;
      height: 100%;
      width: 100%;
      overflow: auto;
      display: flex;
      flex-direction: column;
      gap: 10px;
     
      &::-webkit-scrollbar {
        width: 0.8rem;
        background-color: ${theme.colors.gray200};
        border-radius: ${theme.radius.xs};
      }

      &::-webkit-scrollbar-thumb {
        background-color: ${transparentize(0.5, theme.colors.indigo800)};
      }

      .error-msg {
        font-size: ${theme.font.sizes.xl};
        font-weight: ${theme.font.weights.bold};

        display: flex;
        position: relative;
        justify-content: center;
        align-items: center;

        padding: 10px;
        width: 100%;
        height: 495px;
        justify-content: center;
      }

      .watermark {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 300px;
        opacity: 0.08;
        pointer-events: none;
      }
    }

    .campo-wrapper {
      background-color: ${theme.colors.white};
      border-radius: ${theme.radius.xs};
      border-radius: 12px;
      box-shadow: 0 0 2rem ${theme.colors.gray200};
      padding: ${theme.spacings[8]} ${theme.spacings[16]} ${theme.spacings[8]} ${theme.spacings[16]};
      .titulo-campo {
        font-size: ${theme.font.sizes.xl};
        font-weight: ${theme.font.weights.bold};
      }
      .subtitulo-campo {
        font-size: ${theme.font.sizes.md};
      }
    }

    .values-wrapper {
      padding: 5px 0 5px 20px;
    }

    .value {
      display: flex;
      align-items: center;
      gap: 4px;
      font-size: ${theme.font.sizes.sm};
      color: ${theme.colors.blue600};
      cursor: pointer;
      .value-text{
        max-width: 90%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  `}
`;

export const Loading = styled.div`
  ${({ theme }) => css`
    width: 100%;
    height: 100%;

    display: flex;
    align-items: center;
    justify-content: center;

    background-color: ${transparentize(0.8, theme.colors.black)};

    cursor: progress;
  `}
`;